import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { user_get_all_submissions } from '../../redux/actions/submissionActions'
import { IoPricetagsSharp } from 'react-icons/io5'
import { USER_GET_ALL_SUBMISSIONS_RESET } from '../../redux/types'
import Loader from '../../components/Loader'

const UserDashboardSubmissions = () => {
	const dispatch = useDispatch()

	const userAuth = useSelector((state) => state.userAuth)
	const { userDetail } = userAuth

	const getUserAllSubmissions = useSelector(
		(state) => state.getUserAllSubmissions
	)
	const { loading, userSubmissions } = getUserAllSubmissions

	useEffect(() => {
		dispatch(user_get_all_submissions(userDetail.fullName))

		return () => {
			dispatch({ type: USER_GET_ALL_SUBMISSIONS_RESET })
		}
	}, [dispatch])

	return (
		<>
			<section className='user_dashboard'>
				<div className='container'>
					<div className='row'>
						<div className='col-md-12 text-right mb-5'>
							<Link
								to='/user/dashboard/submissions/create'
								className='btn btn-danger'
							>
								Submit Script
							</Link>
						</div>
						<div className='col-md-12'>
							<div className='row justify-content-center user_dashboard_submissions'>
								{loading ? (
									<Loader />
								) : userSubmissions &&
								  userSubmissions.submissions &&
								  userSubmissions.submissions.length > 0 ? (
									<>
										{userSubmissions.submissions.map((e) => (
											<div key={e._id} className='col-md-10'>
												<div className='user_dashboard_submissions_box'>
													<div className='row no-gutters'>
														<div className='col-md-4'>
															<div className='img_box'>
																<img src={e.image} alt='' className='' />
															</div>
														</div>
														<div className='col-md-8'>
															<div className='box'>
																<div className='row'>
																	<div className='col-md-7'>
																		<h3> {e.title} </h3>
																	</div>
																	<div className='col-md-5 text-right'>
																		<h6>
																			{' '}
																			<IoPricetagsSharp /> {e.category}{' '}
																		</h6>
																	</div>
																	<div className='col-md-12'>
																		<p>
																			{' '}
																			{e.description.substring(
																				0,
																				'120'
																			)}...{' '}
																		</p>
																	</div>
																	<div className='col-md-5'>
																		{e.status == 'In Review' ? (
																			<div>
																				<p>
																					<span className='yellow_dot dot_dot'></span>{' '}
																					{e.status}
																				</p>
																			</div>
																		) : e.status == 'Rejected' ? (
																			<div>
																				<p>
																					<span className='red_dot dot_dot'></span>{' '}
																					{e.status}
																				</p>
																			</div>
																		) : e.status == 'Accepted' ? (
																			<div>
																				<p>
																					<span className='green_dot dot_dot'></span>{' '}
																					{e.status}
																				</p>
																			</div>
																		) : (
																			<div>
																				<p>
																					<span className='black_dot dot_dot'></span>{' '}
																					{e.status}
																				</p>
																			</div>
																		)}
																	</div>
																	<div className='col-md-7 text-right'>
																		<Link
																			to={`/user/dashboard/submissions/${e.title}`}
																			className='btn btn-danger'
																		>
																			View
																		</Link>
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</div>
										))}
									</>
								) : (
									<div className='card'>
										<div className='card-body'>
											<p className='nothing'>No Campaigns found</p>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	)
}

export default UserDashboardSubmissions
